import React from 'react'
import {BrowserRouter, Route, Switch} from 'react-router-dom'

import {RoutePage} from 'src/pages'
import {config} from 'src/shared/config'

export const Routes: React.FC = () => {
  return (
    <BrowserRouter basename={config.basename}>
      <Switch>
        <Route path="/:sharingKey?">
          <RoutePage />
        </Route>
      </Switch>
    </BrowserRouter>
  )
}
